import * as angular from 'angular';
import * as _ from "lodash";
import {LogisticsVehicle} from "../../logistics-vehicle/models/logistics-vehicle.model";
import {DeliveriesService} from "../../deliveries/services/deliveries-service.service";
import {LeanPlanningRequestsService} from "./plan-requests.factory";
import {ServiceAnalysisRequestsService} from "../../service-analysis/services/service-analysis-requests.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {$agentsFactory} from "../../agents/$agents.factory";
import {AssignIgnoreScoreOptionType} from "../../deliveries/types/assign-ignore-score-option.type";
import {SiteContextService} from "../../commons/services/site-context.service";
import {PollingIntervalRef, PollingIntervalService} from "../../commons/services/polling-interval.service";
import {SplitService} from "../../commons/services/split-service.service";
import {ChangeRouteResourceQueryModelModel} from "../../routes/models/change-route-resource-query-model.model";
import {RouteModel} from "../../routes/models/route.model";


export class LeanPlanningDialogService {

  constructor(private $mdDialog, private serviceAnalysisRequestsService: ServiceAnalysisRequestsService, private $delivery, private commonsAlertsService: CommonsAlertsService,
              private leanPlanningRequestsService: LeanPlanningRequestsService, private splitService: SplitService,
              private $serviceAnalysis, private $log, private deliveriesService: DeliveriesService) {
  }


  routingSettings(event, payload) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/routing-settings-dialog.html').default,
      controller: function ($scope) {

        $scope.payload = angular.copy(payload);

        $scope.cancel = self.$mdDialog.cancel;
        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.payload);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editDayTimeSlot(event, timeSlots, timeSlotKey) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/day-time-slot-dialog.html').default,
      controller: function ($scope) {

        $scope.timeSlots = angular.copy(timeSlots);
        $scope.day = timeSlotKey;
        $scope.timeSlotOptions = {
          hours: [],
          minutes: []
        };

        //Hours
        for (let hour = 0; hour <= 23; hour++) {
          $scope.timeSlotOptions.hours.push(hour);
        }
        //Minutes
        for (let minute = 0; minute <= 59; minute++) {
          $scope.timeSlotOptions.minutes.push(minute);
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onAddItem = () => {
          $scope.timeSlots.push({
            fromHour: 0,
            fromMinute: 0,
            toHour: 0,
            toMinute: 0,
            type: "General"
          })
        }

        $scope.onRemoveItem = (itemIndex) => {
          $scope.timeSlots.splice(itemIndex, 1)
        }

        $scope.timeValidationCheck = (index, timeSlotValue) => {
          if (timeSlotValue.fromHour > timeSlotValue.toHour ||
            (_.isEqual(timeSlotValue.fromHour, timeSlotValue.toHour) && timeSlotValue.fromMinute > timeSlotValue.toMinute)) {
            $scope.timeSlots[index].toHour = timeSlotValue.fromHour;
            $scope.timeSlots[index].toMinute = timeSlotValue.fromMinute;
          }
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const uniqTimeSlots = _.uniqWith($scope.timeSlots, _.isEqual);
              self.$mdDialog.hide(uniqTimeSlots);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })

  }

  generatingRoutesDialog(openProcessIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/generating-routes-dialog.html').default,
      controller: function ($scope, pollingIntervalService: PollingIntervalService) {

        let poller: PollingIntervalRef;
        const PULLING_INTERVAL: number = 10000;
        $scope.serviceAnalysis = {};
        $scope.enableCancel = false;
        $scope.isDone = false;

        $scope._getProcess = (processId) => {
          self.serviceAnalysisRequestsService.getGeneratingProcess(processId)
            .then((process) => {
              $scope.serviceAnalysis = process;
            })
        }

        $scope.cancel = () => {
          $scope.enableCancel = true;
          self.serviceAnalysisRequestsService.cancelGeneratingRoutes()
            .then((serviceAnalysis) => {
              if (poller) {
                poller.cancel();
              }
              self.$mdDialog.cancel(serviceAnalysis)
            })
            .catch(() => {
              self.$log.error('Failed to cancel generating routes @leanPlanningView@cancelGenerating')
            })
        }


        if (openProcessIds.length) {
          $scope.selectedProccessId = openProcessIds[0];
          poller = pollingIntervalService.start($scope, () => {
            if ($scope.serviceAnalysis && (_.isEqual($scope.serviceAnalysis.progress, 100) || $scope.serviceAnalysis.status === 'Done')) {
              poller.cancel();
            } else if ($scope.serviceAnalysis.failed || $scope.serviceAnalysis.canceled) {
              poller.cancel();
              self.$mdDialog.cancel($scope.serviceAnalysis);
            } else {
              $scope._getProcess($scope.selectedProccessId);
            }
          }, PULLING_INTERVAL);
        }

        $scope.confirm = () => {
          self.$mdDialog.hide($scope.serviceAnalysis.routeIdList)
        }
      },
      clickOutsideToClose: false
    })

  }

  handleUnpackedServices(services, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/handle-unpacked-services-dialog.html').default,
      controller: function ($scope) {
        $scope.selectedKeys = {};
        $scope.selectedIds = [];
        $scope.unpackedItemByServiceKeys = {};

        $scope.services = services;
        $scope.isRemoveDisabled = true;

        _.forEach(services, (service) => {
          $scope.unpackedItemByServiceKeys[service.id] = self.deliveriesService.getUnpackedPackages(service.packageList[0].items);
        });

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onToggle = (id) => {
          const idIndex = _.indexOf($scope.selectedIds, id);
          if (idIndex === -1) {
            $scope.selectedIds.push(id);
          } else {
            $scope.selectedIds.splice(idIndex, 1);
          }
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selectedIds);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  manualAssignRoute(event, routeId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/assign-agent-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $route, siteContextService: SiteContextService) {


        const assignIgnoreScoreOption = siteContextService.getSiteInfo().assignIgnoreScoreOption;
        $scope.isShowAllToggleVisible = true;
        $scope.isIgnoreScore = false;

        if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOn) {
          $scope.isIgnoreScore = true;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOff) {
          $scope.isIgnoreScore = false;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.Hide) {
          $scope.isIgnoreScore = false;
          $scope.isShowAllToggleVisible = false;
        }

        $scope.routeId = routeId;
        $scope.serviceIds = [];
        $scope.assignData = undefined;
        $scope.assignServices = true;

        $scope.selectedType = 'Location';

        $scope.cancel = self.$mdDialog.cancel;

        $route(routeId).$asyncValue()
          .then((route) => {
            $scope.serviceIds = route.serviceIdList;
          })

        $scope.onToggleIsIgnoreScore = (isIgnoreScore: boolean) => {
          $scope.isIgnoreScore = isIgnoreScore;
        }

        // ******************************
        //        Private methods
        // ******************************


        // $scope._getData = (routeId, type, query) => {
        //   $scope.loading = true;
        //   return this.leanPlanningRequestsService.getAssignSuggestions(routeId, type, query)
        //     .then((data) => {
        //       $scope.assignData = data;
        //       $scope.serviceIds = data.deliveryIds;
        //     })
        //     .catch((error) => {
        //       this.$log.error('Failed to get assign data ' +
        //         '@deliveriesDialogService@manualAssign@_getData', error);
        //       this.commonsAlertsService.somethingWentWrongError();
        //     });
        // }



        // ******************************
        //        Public methods
        // ******************************

        $scope.onAssign = (agent, relatedServicesIds, doForce) => {
          self.$mdDialog.hide({
            agentId: _.get(agent, 'id'),
            doForce: doForce,
            assignServices: $scope.assignServices
          });
        }
      }
    })
  }

  routeResourcesAssigment(ids: string[], step: 'agent-assign' | 'agent-associate' | 'assistant' | 'vehicle' = 'agent-assign', route?: RouteModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('../views/dialogs/route-resources-assignment-dialog.html').default,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.cancel = self.$mdDialog.cancel;
        $scope.step = step;
        $scope.routeIds = ids;
        $scope.route = route;
      }
    });
  }

  manualAssignRoutes(event, routeIds, isAssociateMode?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/assign-agent-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $route, siteContextService: SiteContextService) {

        const assignIgnoreScoreOption = siteContextService.getSiteInfo().assignIgnoreScoreOption;
        $scope.isShowAllToggleVisible = true;
        $scope.isIgnoreScore = false;

        if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOn) {
          $scope.isIgnoreScore = true;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOff) {
          $scope.isIgnoreScore = false;
        } else if (assignIgnoreScoreOption === AssignIgnoreScoreOptionType.Hide) {
          $scope.isIgnoreScore = false;
          $scope.isShowAllToggleVisible = false;
        }

        $scope.routeIds = routeIds;
        $scope.serviceIds = [];
        $scope.assignData = undefined;
        $scope.assignServices = true;
        $scope.isAssociateMode = isAssociateMode;

        $scope.selectedType = 'Location';

        $scope.cancel = self.$mdDialog.cancel;

        $route().$asyncValues(routeIds)
          .then((routes) => {
            $scope.serviceIds = _.flatMap(routes, 'serviceIdList');
          })

        $scope.onToggleIsIgnoreScore = (isIgnoreScore: boolean) => {
          $scope.isIgnoreScore = isIgnoreScore;
        }

        // ******************************
        //        Private methods
        // ******************************


        // $scope._getData = (routeId, type, query) => {
        //   $scope.loading = true;
        //   return this.leanPlanningRequestsService.getAssignSuggestions(routeId, type, query)
        //     .then((data) => {
        //       $scope.assignData = data;
        //       $scope.serviceIds = data.deliveryIds;
        //     })
        //     .catch((error) => {
        //       this.$log.error('Failed to get assign data ' +
        //         '@deliveriesDialogService@manualAssign@_getData', error);
        //       this.commonsAlertsService.somethingWentWrongError();
        //     });
        // }



        // ******************************
        //        Public methods
        // ******************************

        $scope.onAssign = (agent, relatedServicesIds, doForce) => {
          self.$mdDialog.hide({
            agentId: _.get(agent, 'id'),
            branchIds: _.get(agent, 'branchIds'),
            doForce: doForce,
            assignServices: $scope.assignServices
          });
        }
      }
    })
  }

  editRouteSettings(settings, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/route-settings-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.considerTimeWindows = angular.copy(!settings.ignoreTimeWindows);
        $scope.considerResourceEndTime = angular.copy(!settings.ignoreResourceEndTime);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const settingsRef = angular.copy(settings);
              settingsRef.ignoreTimeWindows = !$scope.considerTimeWindows;
              settingsRef.ignoreResourceEndTime = !$scope.considerResourceEndTime;

              self.$mdDialog.hide(settingsRef);
            }
          }
        }

      }
    })
  }

  routeReset(route) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/reset-route-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.resetOnlyAssignAgentServices = false;
        $scope.route = route;
        $scope.routeId = route.rid;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          self.$mdDialog.hide({routeId: route.rid, resetOnlyAssignAgentServices: $scope.resetOnlyAssignAgentServices});
        }

      }
    })
  }

  updateResource(route: any, showConfiguration?: boolean) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/update-resource-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $deliveries, $filter) {
        $scope.route = route;
        $scope.initialAllocationId = _.get(route.planningResource, 'allocationTimeWindowId')
        $scope.resourceId = route.planningResource.allocationId;
        $scope.resourceAllocationId = $scope.route.planningResource.allocationId;
        $scope.resourceAllocation = route.planningResource.allocationId ? {
          resourceName: $scope.route.supplyResourceName,
          startTime: _.get(route.planningResource, 'notBefore'),
          branchIds: _.get(route, 'branchIds'),
          timeWindowId: _.get(route.planningResource, 'allocationTimeWindowId'),
        } : undefined;

        const agentUser = _.get($scope.route.planningResource, 'agentBinding.user');
        $scope.selectedResourceData = $scope.resourceAllocationId ? {
          agentName: agentUser ? $filter('userName')(agentUser) : undefined,
          capacity: $scope.route.planningResource.planningCapacity,
          serviceAreaIds: _.get($scope.route, 'serviceAreaIdList', []),
          allocationSkills: _.get($scope.route, 'requiredSkills', []),
        } : undefined;

        $scope.loading = false;
        $scope.from = route.planningResource.notBefore;
        $scope.to = route.planningResource.notAfter;
        $scope.branchIds = [];
        $scope.skills = [];

        $scope.showConfiguration = showConfiguration;
        if (showConfiguration) {
          $scope.rePrice;
          $scope.sendSms;

          $scope.updateExistingRouteResource = self.splitService.getUpdateExistingRouteResourceDefault();
          $scope.updateRouteServicesTimeWindows = self.splitService.getUpdateRouteServicesTimeWindowsDefault();
        }

        $scope.cancel = self.$mdDialog.cancel;

        ////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onUpdateExistingRouteResourceChange = () => {
          $scope.updateExistingRouteResource = !$scope.updateExistingRouteResource;
        }

        $scope.onUpdateRouteServicesTimeWindowsChange = () => {
          $scope.updateRouteServicesTimeWindows = !$scope.updateRouteServicesTimeWindows;

          if (!$scope.updateRouteServicesTimeWindows) {
            $scope.rePrice = undefined;
            $scope.sendSms = undefined;
          }
        }

        $scope.onRePriceChange = () => {
          $scope.rePrice = !$scope.rePrice;
        }

        $scope.onSendSmsChange = () => {
          $scope.sendSms = !$scope.sendSms;
        }

        $scope.onRangeChange = (from, to) => {
          $scope.from = from;
          $scope.to = to;
        }


        $scope.onAllocationSelect = (resourceAllocation) => {
          $scope.resourceAllocation = resourceAllocation;
          $scope.resourceAllocationId = resourceAllocation.id;

          const agentUser = _.get(resourceAllocation, 'agentBinding.user');
          $scope.selectedResourceData = resourceAllocation ? {
            agentName: agentUser ? $filter('userName')(agentUser) : undefined,
            serviceAreaIds: _.get(resourceAllocation, 'serviceAreaIds', []),
            capacity: _.get(resourceAllocation, 'capacity', {}),
            allocationSkills: _.get(resourceAllocation, 'requiredSkills', []),
            startTime: _.get(resourceAllocation, 'schedule.startTime'),
            branchIds: _.get(resourceAllocation, 'branchIds')
          } : undefined;
        }


        $scope.confirm = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const payload: {allocation, queries?: ChangeRouteResourceQueryModelModel} = {
                allocation: $scope.resourceAllocation,
              }

              if (!!showConfiguration) {
                payload.queries = {
                  updateExistingRouteResource: $scope.updateExistingRouteResource,
                  updateRouteServicesTimeWindows: $scope.updateRouteServicesTimeWindows,
                  rePrice: $scope.rePrice,
                  sendSms: $scope.sendSms
                }
              }

              self.$mdDialog.hide(payload);
              // this.$mdDialog.hide($scope.resourceAllocation);
            }
          }
        }
      }
    });
  }

  onEditTaskBoundEquipment(task, branchIds?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-task-bound-equipment-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.task = angular.copy(task);
        $scope.branchIds = branchIds;
        $scope.subTaskIndex = undefined;

        if ($scope.task.subTasks && ($scope.task.taskSpec.purpose === 'StartRoute' || $scope.task.taskSpec.purpose === 'EndRoute')) {

          $scope.subTaskIndex = _.findIndex($scope.task.subTasks, (st: any) => {
            return _.find(st.actions, (ac) => {
              return ac.type === "VehicleBinding";
            })!!
          })

          // sort the action to be with the main logistic vehicle first
          if (_.isNumber($scope.subTaskIndex) && $scope.subTaskIndex !== -1) {
            $scope.task.subTasks[$scope.subTaskIndex].actions = _.orderBy($scope.task.subTasks[$scope.subTaskIndex].actions, [function (ac) {
                return ac.type === 'VehicleBinding' && ac?.logisticsVehicleReference?.vehicleType !== 'Trailer'
              }],
              ['desc']);
          }
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onLogisticsVehicleSelect = (logisticsVehicle, index) => {
          _.set($scope.task.subTasks[$scope.subTaskIndex], `actions[${index}].logisticsVehicleId`, logisticsVehicle.id);
        }


        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.task);
            }
          }
        }


      }
    })
  }

  onUpdateRouteBoundEquipment(route, branchIds?: string[], event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/update-route-bound-equipment-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.route = route;
        $scope.branchIds = branchIds;
        $scope.mainLogisticVehicle = route.planningResource.mainLogisticsVehicleReference;
        if (route.planningResource.attachedLogisticsVehicleReferences?.length) {
          $scope.attachedLogisticVehicle = route.planningResource.attachedLogisticsVehicleReferences[0];
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        // ******************************
        // External methods
        // ******************************

        $scope.onMainLogisticsVehicleSelect = (logisticsVehicle?: LogisticsVehicle) => {
          $scope.mainLogisticVehicle = logisticsVehicle;
        }

        $scope.onAttachedLogisticsVehicleSelect = (logisticsVehicle?: LogisticsVehicle) => {
          $scope.attachedLogisticVehicle = logisticsVehicle;
        }

        $scope.onSubmit = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            self.$mdDialog.hide({
              mainLogisticVehicle: $scope.mainLogisticVehicle,
              attachedLogisticVehicle: $scope.attachedLogisticVehicle
            });
          }

        }


      }
    })
  }

  manageAssistants(route, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/manage-assistants-dialog.html').default,
      controller: function ($scope, $agentAssistants, $infiniteScroll, $agents: $agentsFactory) {

        const agentsRef = $agents(),
          loadLimit = 20;

        $scope.route = route;
        $scope.excludeKeys = {};

        if (route.agentId) {
          $scope.excludeKeys[route.agentId] = true;
        }

        $scope.queryString = undefined;
        $scope.selectedKeys = {};

        _.forEach(route.assistantAgentReferences, (a) => {
          $scope.selectedKeys[a.id] = true;
        })

        agentsRef.$query(_getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll(agentsRef, loadLimit, {getFullData: true});


        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
          _query();
        }

        $scope.onToggle = (agent) => {
          $scope.selectedKeys[agent.id] = !$scope.selectedKeys[agent.id];
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const updatedAssistants = _.keys(_.pickBy($scope.selectedKeys, _.identity))
              self.$mdDialog.hide(updatedAssistants);
            }
          }
        };

        function _query() {
          agentsRef.$query(_getQueryPayload())
            .then(() => {
              $scope.infiniteScroll.reload();
            })
        }

        function _getQueryPayload() {
          return {
            limit: loadLimit,
            excludeId: $scope.route?.agentId,
            branchIds: $scope.route?.branchIds,
            query: $scope.queryString
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }


}

angular
  .module('bringoz.admin.lean-planning')
  .service('leanPlanningDialogService', LeanPlanningDialogService);
